import styled from 'styled-components';

export const ViewRightWrapper = styled.div`
  width: ${(props) => (props.columns === 3 ? `${200/3}%` : `${100 / props.columns}%`)};
  height: 100%;
  background: transparent;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  border: solid 2px ${(props) => {
    const typeOption = props.layoutElement.initOptions?.typeOption;
    const is3DModeEnabled = props.is3DModeEnabled;
    const selectedView = props.selectedView;
    const theme = props.theme.colors;
  
    const borderColorMPR = selectedView
      ? (typeOption?.includes('coronal') && theme.borderRed) ||
        (typeOption?.includes('axial') && theme.borderGreen) ||
        (typeOption?.includes('sagital') && theme.borderBlue) ||
        theme.highlightBlue
      : theme.gray800;
  
    const borderColorVR = selectedView ? theme.borderYellow : theme.gray800;
  
    return is3DModeEnabled ? borderColorVR : borderColorMPR;
  }};
  position: absolute;
  right: 0;
  z-index: 1;
`;
